/* eslint-disable react-hooks/exhaustive-deps */

import { TransactionReceipt } from '@ethersproject/providers';
import { useMemo } from 'react';
import useSnackbarSuccess from '../hooks/useSnackbarSuccess';
import useTranslate from '../hooks/useTranslate';

const useSnackbarRpcSuccess = (data?: TransactionReceipt) => {
  const translate = useTranslate();

  const dataWithMessage = useMemo(() => {
    if (data) {
      return { message: translate('success:default') };
    }
  }, [data]);

  return useSnackbarSuccess(dataWithMessage);
};

export default useSnackbarRpcSuccess;
